<template>
  <DeliveryNoteList :customer="''"/>
</template>

<script>
import DeliveryNoteList from '@/components/documents/DeliveryNoteList.vue'

export default {
  name: 'DeliveryNoteListView',
  components: {
    DeliveryNoteList
  }
}
</script>
